<template>
    <div class="o-page__card" style="padding-top: 15%;">
        <el-alert class="u-mb-small"
            v-if="loginError"
            :title="loginError"
            type="error"
            show-icon>
        </el-alert>
        <div class="c-card u-mb-xsmall" v-loading="loggingIn">
            <!-- <p v-if="loginError">{{ loginError }}</p> -->
            <form class="c-card__body" @submit.prevent="loginSubmit">
                <div class="c-field u-mb-small">
                    <label class="c-field__label" for="input1">NPP</label>
                    <input class="c-input" type="text" v-model="npp" placeholder="your NPP">
                </div>
                <div class="c-field u-mb-small">
                    <label class="c-field__label" for="input2">Password</label>
                    <input class="c-input" type="password" v-model="password" placeholder="Enter password">
                </div>
                <button class="c-btn c-btn--info c-btn--fullwidth" type="submit">Sign In</button>
            </form>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    export default {
        name: 'login',
        data() {
            return {
                npp: '',
                password: ''
            }
        },
        computed: {
            ...mapState([
                'loggingIn',
                'loginError'
            ])
        },
        methods: {
            ...mapActions([
                'doLogin'
            ]),
            loginSubmit() {
                this.doLogin({
                    npp: this.npp,
                    password: this.password
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>